import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "../../layout/AppLayout";
import { ErpTable } from "../../components/erp";
import { errorText } from "../../api/client";
import { salesApi, PiListRow } from "./api";

/** Port of ApiV2/Exports/Controller/ProformaListController.php (v3/Sales/PIList.php) - the Sales
 * "dashboard" landing list: Proforma Invoices (PI = Sales Order) not yet on a Custom Invoice.
 * Live data: ScrmPIData (6,887 rows in QA), paginated 100/page same as source. */
export default function PiListPage() {
  const [pageNo, setPageNo] = useState(1);
  const [searchKey, setSearchKey] = useState("");
  const list = useQuery({ queryKey: ["sales", "pi-list", pageNo, searchKey], queryFn: () => salesApi.piList({ PageNo: pageNo, SearchKey: searchKey || undefined }) });

  return (
    <>
      <PageHeader title="Sales Orders (PI List)" location="Sales" />
      <div className="card mb-3"><div className="card-body d-flex gap-2 align-items-end">
        <div>
          <label className="form-label">Search</label>
          <input className="form-control" data-testid="pi-search-input" placeholder="Buyer / PO No / PI No"
            value={searchKey} onChange={(e) => { setSearchKey(e.target.value); setPageNo(1); }} />
        </div>
      </div></div>
      <div className="card"><div className="card-body">
        <div className="mb-3"><strong data-testid="pi-total-count">{list.data?.TotalCount ?? 0} orders</strong></div>
        <ErpTable<PiListRow> testId="pi-list-table" loading={list.isLoading} error={list.isError ? errorText(list.error) : null}
          rows={list.data?.Data || []} columns={[
            { key: "SNO", title: "#" }, { key: "PInvNumber", title: "PI No" }, { key: "PInvDate", title: "PI Date" },
            { key: "PoNo", title: "PO No" }, { key: "Buyer", title: "Buyer" }, { key: "ShipByDate", title: "Ship By" },
            { key: "Status", title: "Status" },
          ]} />
        <div className="d-flex gap-2 mt-3">
          <button className="btn btn-outline-secondary" data-testid="pi-prev-page" disabled={pageNo <= 1} onClick={() => setPageNo((p) => p - 1)}>Prev</button>
          <span data-testid="pi-page-no">Page {pageNo} of {list.data?.PageCount ?? 1}</span>
          <button className="btn btn-outline-secondary" data-testid="pi-next-page" disabled={!list.data?.RecordsAval} onClick={() => setPageNo((p) => p + 1)}>Next</button>
        </div>
      </div></div>
    </>
  );
}
